module.exports = __webpack_public_path__ + "img/file-ilu.1e8da43b.svg";